import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CryptoJS from 'crypto-js';
import { Link } from 'react-router-dom';
import MainCardContainer from '../../components/MainCardContainer/';
import CardRow from './../../components/CardRow';
import { Card, CardTitle } from 'material-ui/Card';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { DefaultButton } from '../../components/Buttons';
import { withStyles } from '@material-ui/core/styles';
import * as actions from './../../data/impersonate/action';
import { LAST_BID_SCOPE_USE, REGULAR_BID_SCOPE, STAFFID } from './../../data/constants/';
import { login } from '../../settings/settings';
import * as loginActions from './../../data/login/productionActions';
import { useLanguage } from '../../context/LanguageContext';

import './styles.scss';

const SelectButton = withStyles({
  root: {
    backgroundColor: 'transparent',
    borderColor: '#5396E4',
    height: '40px'
  }
})(DefaultButton);

const AutocompleteImp = withStyles({
  inputRoot: {
    width: '400px',
    height: '40px',
    padding: '0px !important'
  }
})(Autocomplete);

const Impersonate = (props) => {
  const { labels } = useLanguage();
  const commonLabels = labels.commonLabels || {};
  const IMPERSONATE = labels.IMPERSONATE || {};
  const [value, setValue] = useState('');
  const [staffs, setStaffs] = useState([]);
  const [disable, setDisable] = useState(true);
  const [pass, setPass] = useState('');

  useEffect(() => {
    const { fetchAllStaff } = props;
    fetchAllStaff().then(response => {
      setStaffs(response.data);
      setValue(response.data[0].staffId);
    });
  }, [props]);

  const handleChange = (event, newValue) => {
    // Reset the last bid scope use when the crew member changes
    sessionStorage.setItem(LAST_BID_SCOPE_USE, REGULAR_BID_SCOPE);
    event.preventDefault();
    setValue(newValue);
    setDisable(false);
  };

  const handleClear = () => {
    setValue(0);
    setDisable(true);
  };

  const handleStaffSelect = () => {
    const username = value.value;
    if (login.authType === 'OIDC') {
      sessionStorage.setItem(STAFFID, username);
      sessionStorage.setItem('admin', commonLabels.ADMIN);
      props.fetchLoginOIDC();
      return;
    }

    const decryptedPass = CryptoJS.AES.decrypt(
      pass.toString(),
      'aDopT'
    ).toString(CryptoJS.enc.Utf8);
    const { fetchStaffLogin } = props;
    if (username !== commonLabels.ADMIN) {
      sessionStorage.setItem('admin', commonLabels.ADMIN);
      fetchStaffLogin(username, decryptedPass);
    } else {
      sessionStorage.setItem('admin', '');
      fetchStaffLogin(username, decryptedPass);
    }
  };

  const menuItems = () => {
    return staffs.map((staff) => ({
      label: `${staff.staffId}-${staff.name}`,
      value: `${staff.staffId}`
    }));
  };

  return (
    <div>
      <MainCardContainer
        headTitle={IMPERSONATE.HEAD_TITLE}
        content={[
          <Card style={{ marginTop: 20 }} key={`impersonate-card`}>
            <CardTitle
              title={IMPERSONATE.CARD_TITLE}
              className='card-title'
            />
            <CardRow
              key={1}
              cardNumber={1}
              cards={[
                <div
                  className='language-bar'
                  key={`impersonate-language-bar`}
                >
                  <div className='buttons-wrapper'>
                    <AutocompleteImp
                      options={menuItems()}
                      getOptionLabel={(option) => option.label || ''}
                      getOptionSelected={(option, value) =>
                        option.id === value.id
                      }
                      value={value}
                      onChange={handleChange}
                      renderInput={(params) => (
                        <TextField {...params} variant='outlined' />
                      )}
                    />
                    <div style={{ marginTop: '15px' }}>
                      <SelectButton
                        className={'button-actions'}
                        disabled={disable}
                      >
                        <Link to={''} onClick={handleStaffSelect}>
                          {IMPERSONATE.SELECT_BUTTON}
                        </Link>
                      </SelectButton>
                    </div>
                  </div>
                </div>
              ]}
            />
          </Card>
        ]}
      />
    </div>
  );
};

Impersonate.defaultProps = {
  fetchStaffLogin: function fetchStaffLogin() {},
  fetchLoginOIDC: function fetchLoginSSO() {},
  location: {},
  allstaff: {},
  redirect: function redirect() {},
  fetchAllStaff: function fetchAllStaff() {},
  error: {}
};

Impersonate.propTypes = {
  fetchStaffLogin: PropTypes.func,
  fetchAllStaff: PropTypes.func,
  fetchLoginOIDC: PropTypes.func,
  location: PropTypes.object,
  allstaff: PropTypes.object,
  redirect: PropTypes.func,
  error: PropTypes.shape({
    loginError: PropTypes.bool,
    message: PropTypes.string
  })
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  fetchStaffLogin: (user, pass) =>
    dispatch(actions.default.fetchStaffLogin(user, pass)),
  redirect: path => dispatch(actions.default.redirect(path)),
  fetchAllStaff: () => dispatch(actions.default.fetchAllStaff()),
  fetchLoginOIDC: () => dispatch(loginActions.fetchLoginOIDC()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Impersonate);
